import { Box, styled } from '@mui/material'
import { keyframes } from '@mui/system'

type PaletteColor =
  | 'primary'
  | 'secondary'
  | 'error'
  | 'warning'
  | 'info'
  | 'success'

interface PulseIndicatorProps {
  size?: number
  color?: PaletteColor
}

const pulseAnimation = keyframes`
  0% {
    box-shadow: 0 0 0 0 var(--pulse-color);
  }
  100% {
    box-shadow: 0 0 0 var(--pulse-spread) var(--pulse-color-transparent);
  }
`

export const PulseIndicator = styled(Box, {
  shouldForwardProp: (prop) => prop !== 'size' && prop !== 'color',
})<PulseIndicatorProps>(({ theme, size = 8, color = 'warning' }) => ({
  width: size,
  height: size,
  borderRadius: '50%',
  backgroundColor: theme.palette[color].main,
  '--pulse-color': theme.palette[color].main,
  '--pulse-color-transparent': `${theme.palette[color].main}00`,
  '--pulse-spread': `${size * 0.7}px`,
  animation: `${pulseAnimation} 1.5s infinite ease-in-out`,
  flexShrink: 0,
}))
